module.exports = __webpack_public_path__ + "static/img/xawyjyxx.e3b92fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tabs/xawyjyxx.png
// module id = +mMy
// module chunks = 1